var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextSnippet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80833 1.66667L13.8333 5.69167V13.3333H2.16667V1.66667H9.80833ZM9.80833 0H2.16667C1.25 0 0.5 0.75 0.5 1.66667V13.3333C0.5 14.25 1.25 15 2.16667 15H13.8333C14.75 15 15.5 14.25 15.5 13.3333V5.69167C15.5 5.25 15.325 4.825 15.0083 4.51667L10.9833 0.491667C10.675 0.175 10.25 0 9.80833 0ZM3.83333 10H12.1667V11.6667H3.83333V10ZM3.83333 6.66667H12.1667V8.33333H3.83333V6.66667ZM3.83333 3.33333H9.66667V5H3.83333V3.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSnippet);
export default __webpack_public_path__ + "static/media/text-snippet.dcdc6696.svg";
export { ForwardRef as ReactComponent };